import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  NotificationIconButton, NotificationBadge,
} from './styles';
import CartTooltipContent from './CartTooltipContent';
import HeaderTooltip from './headerTooltip';
import {Bookmark as BookmarkIcon } from '@mui/icons-material';
import CartIcon from '../../assets/CartIcon.svg';
import { HeaderCartClick, HeaderCartDialogueView, sendGA4Data } from '../../analytics/events';
import { useTranslatedObject } from '../../utils/translation';
import { CONFIG } from '../../utils/config';

const NotificationBadges = ({ id, ariaLabel, icon, badgeCount, onMouseOverOnIconButton, onClickOnIconButton, onMouseLeaveOnIconButton }) => (
  <NotificationBadge 
    id={`${id}-badge`}
    badgeContent={badgeCount}
  >
    <NotificationIconButton 
      id={`${id}-button`}
      aria-label={ariaLabel}
      onMouseEnter={onMouseOverOnIconButton}
      onMouseLeave={onMouseLeaveOnIconButton}
      onClick={onClickOnIconButton}
    >
      {icon}
    </NotificationIconButton>
  </NotificationBadge>
);

const NotificationItem = memo(({ 
  showCart = true,
  cartData,
  isCartLoading,
  isCartError,
  navigate
}) => {
  const cartItemCount = cartData?.items?.length || 0;
  const cartHoverTracked = useRef(false);
  const onMouseOverOnNotificationIconButton = () => {
    if(cartHoverTracked.current) return;
    sendGA4Data(HeaderCartDialogueView);
    cartHoverTracked.current = true;
  }
  const onMouseLeaveOnNotificationIconButton = () => {
    cartHoverTracked.current = false;
  }

  const onClickOnNotificationIconButton = () => {
    sendGA4Data(HeaderCartClick);
    const cartUrl = `${CONFIG.LEGACY_APP_URL}/checkout/cart`;
    navigate(cartUrl);
  };

  const configuration = useTranslatedObject('configuration')

  return (
    <React.Fragment>
      {configuration.showBookmarks && (
        <NotificationBadges
          id="desktop-bookmarks"
          ariaLabel="View bookmarks"
          icon={<BookmarkIcon />}
          badgeCount={0}
        />
      )}
      {showCart && (
        <HeaderTooltip
          variant="cart"
          title={
            <CartTooltipContent
              cartData={cartData}
              isLoading={isCartLoading}
              isError={isCartError}
              navigate={navigate}
            />
          }
          arrow
          placement="bottom-end"
          enterDelay={200}
          leaveDelay={200}
          showCloseIcon={true}
        >
          <Box component="span">
            <NotificationBadges
              id="desktop-cart"
              ariaLabel="View cart"
              icon={<CartIcon />}
              badgeCount={cartItemCount}
              onMouseOverOnIconButton={onMouseOverOnNotificationIconButton}
              onMouseLeaveOnIconButton={onMouseLeaveOnNotificationIconButton}
              onClickOnIconButton={onClickOnNotificationIconButton}
            />
          </Box>
        </HeaderTooltip>
      )}
    </React.Fragment>
  );
});

NotificationItem.displayName = 'NotificationItem';

NotificationItem.propTypes = {
  showBookmarks: PropTypes.bool,
  showCart: PropTypes.bool,
  cartData: PropTypes.shape({
    items: PropTypes.array
  }),
  isCartLoading: PropTypes.bool,
  isCartError: PropTypes.bool,
  navigate: PropTypes.func
};

export default NotificationItem;